import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BenefitsTabs from './BenefitsTabs/BenefitsTabs';
import CustomerGroupModal from './CustomerGroupModal/CustomerGroupModal';
import DeleteModal from './DeleteModal/DeleteModal';
import SelectedBenefitsError from './SelectedBenefitsError/SelectedBenefitsError'
import _ from 'lodash';
import NoGroupModal from './NoGroupModal/NoGroupModal'

class BenefitsLadder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerModal: false,
            deleteModal: false,
            deleteGroupName: "",
            data: null,
            selectedBenefit: true,
            selectedBenefitMoadl: false,

        }
    }
    onChangeSelectedBenefit=()=>{
        this.setState({selectedBenefit: false})
    }
    componentWillMount() {
        localStorage.setItem("openedTool", this.props.projectId);
        let body = {
            projectId: this.props.projectId,
            type: "benefitsLadder"
        }
        let body1 = {
            projectId: this.props.projectId,
            type: "influencerMap"
        }
        this.props.getCustomerGroup(body1)
        this.props.getBenefitsLadder(body)
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.step1 && nextProps.benefits.addGroupFetched) {
            if (this.state.step1 && nextProps.benefits.benefitsLadderFetching) {
                this.setState({
                    step1: false,
                    customerModal: false
                })
            }
            let body = {
                projectId: this.props.projectId,
                type: "benefitsLadder"
            }
            this.props.getBenefitsLadder(body)
        }
    }
    onPlusBtn = () => {
        this.setState({
            customerModal: true
        })
        let body = {
            projectId: this.props.projectId,
            type: "influencerMap"
        }
        this.props.getCustomerGroup(body)
    }
    onAddCustomerGroup = (requestData, step) => {
        if (step === "1") {
            let body = {
                projectId: this.props.projectId,
                type: "benefitsLadder",
                status: 'finished',
                data: [
                    {
                        groupId: requestData.groupId,
                        groupName: requestData.groupName,
                        values: [],
                        benefits: [],
                        attributes: []
                    }
                ]
            }
            this.setState({
                step1: true,
            })
            this.props.addCustomerGroup1(body)
        }
        if (step !== "1") {
            let data = this.props.benefits.benefitsLadderData.Items[0].data;
            let addingGroup = {
                groupId: requestData.groupId,
                groupName: requestData.groupName,
                values: [],
                benefits: [],
                attributes: []
            }
            data.push(addingGroup)
            let body = {
                id: this.props.benefits.benefitsLadderData.Items[0].id,
                type: "benefitsLadder",
                data: data,
                status: 'finished',
            }
            this.props.addCustomerGroup2(body)
            this.setState({
                customerModal: false
            })
        }
    }
    deleteCustomerGroup = () => {
        let data = [];
        this.props.benefits.benefitsLadderData.Items[0].data.map(item => {
            if (item.groupName !== this.state.deleteGroupName) {
                data.push(item)
            }
        })
        this.props.benefits.benefitsLadderData.Items[0].data = data
        let body = {
            id: this.props.benefits.benefitsLadderData.Items[0].id,
            type: "benefitsLadder",
            data: data,
            status: 'finished',
        }
        this.setState({
            deleteModal: false,
            deleteGroupName: ""
        })
        this.getBenfitsData(data)
        this.props.deleteCustomerGroup(body)
    }
    onDeleteModalOpen = (data) => {
        this.setState({
            deleteGroupName: data.groupName,
            deleteModal: true
        })
    }
    onDeleteModalClose = () => {
        this.setState({
            deleteGroupName: "",
            deleteModal: false
        })
    }
    onAddCustomerGroupClose = () => {
        this.setState({
            customerModal: false
        })
    }
    //function for geting data from benefitsTabs
    getBenfitsData = (data) => {
        this.setState({
            data: data
        }, () => this.onCheckBenefit())
    }
    //function for checking selected benefit
    onCheckBenefit = () => {
        let important = {}
        this.state.data.map((item, key) => {
            for (let i of item.benefits) {
                let include = _.includes(i, true)
                if (include) {
                    important[key] = include;
                    break;
                }
                important[key] = include;
            }
        })
        if (_.includes(important, false)) {
            this.setState({
                selectedBenefit: true
            })
        }
        if (!(_.includes(important, false))) {
            this.setState({
                selectedBenefit: false
            })
        }
    }
    saveNewData = (newData) => {
      this.getBenfitsData(newData)

      let body = {
        id: this.props.benefits.benefitsLadderData.Items[0].id,
        type: "benefitsLadder",
        data: this.state.data
      }
      this.props.editCustomerGroup(body)
    }
    onNextButtonClick = () => {
        if (this.state.selectedBenefit || this.props.benefits.benefitsLadderData.Items[0].data.length === 0) {
            this.setState({
                selectedBenefitMoadl: true
            })
        }
        else {
            let body = {
                id: this.props.benefits.benefitsLadderData.Items[0].id,
                type: "benefitsLadder",
                data: this.state.data,
                status: 'finished',
            }
            this.props.editCustomerGroup(body)
            this.props.goBack()
        }
    }
    onSelectedModalClose = () => {
        this.setState({
            selectedBenefitMoadl: false
        })
    }
    render() {
        return (
            <React.Fragment>
                {!this.props.benefits.benefitsLadderFetched && <div></div>}
                {this.props.benefits.benefitsLadderFetched && <div className='projects-content challenge-statement-content'>
                    <div className='step-bar'>
                        <div className='step step-two arrow-step active-step'>
                            <p>Step 1</p>
                        </div>
                        <div className='step step-two arrow-step'>
                            <p>Result</p>
                        </div>
                    </div>
                    <div className='container-fluid'>
                        <div className="row">
                          <div className="col-sm-12">
                            <h5>BENEFITS LADDER</h5>
                          </div>
                        </div>
                        <div className='row'>
                            <div className="col-sm-12">
                              <div className="card">
                                <div className="card-header">
                                  <h5 style={{ marginBottom: "0px" }}>Add customer groups, brainstorm and prioritize</h5>
                                  <p><i>“Click the ‘+” sign to add one of your top 3 Influencer Map Customer Group Priorities.  Brainstorm the values, benefits and attributes of the Customer Group.  Check the box for the most important Values and Benefits for this Customer Group.</i></p>
                                </div>
                                <div className="card-body">
                                  <BenefitsTabs
                                      onPlusBtn={this.onPlusBtn}
                                      getBenefitsLadder={this.props.getBenefitsLadder}
                                      benefits={this.props.benefits}
                                      onDeleteModalOpen={this.onDeleteModalOpen}
                                      getBenfitsData={this.getBenfitsData}
                                      onChangeSelectedBenefit={this.onChangeSelectedBenefit}
                                      tabStep={this.props.tabStep}
                                      onTabChange={this.props.onTabChange}
                                      saveNewData={this.saveNewData}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.customerModal && <CustomerGroupModal
                                benefits={this.props.benefits}
                                onAddCustomerGroup={this.onAddCustomerGroup}
                                onAddCustomerGroupClose={this.onAddCustomerGroupClose}
                            />
                            }
                            {
                                this.state.deleteModal && <DeleteModal
                                    onDeleteModalClose={this.onDeleteModalClose}
                                    deleteCustomerGroup={this.deleteCustomerGroup}
                                />
                            }
                            {
                                this.props.benefits.customerGroupFetched && this.props.benefits.customerGroupData.length === 0 &&
                                <NoGroupModal />
                            }
                            {
                                this.state.selectedBenefitMoadl && <SelectedBenefitsError
                                    onSelectedModalClose={this.onSelectedModalClose}
                                />
                            }
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                        <a href="/toolkit" className='btn empty-btn default'>Back</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </React.Fragment>
        )
    }
}

export default (BenefitsLadder);



// WEBPACK FOOTER //
// ./src/components/BenefitsLadder/BenefitsLadder.jsx